import { Button } from '@curology/ui-components-web/react/Button';
import { Modal } from '@curology/ui-components-web/react/Modal';
import { ModalContent } from '@curology/ui-components-web/react/Modal/ModalContent';
import { ModalFooter } from '@curology/ui-components-web/react/Modal/ModalFooter';
import { ModalHeader } from '@curology/ui-components-web/react/Modal/ModalHeader';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

const SubscriptionTermsModal = ({
  setShowModal,
  showModal,
}: {
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  showModal: boolean;
}) => {
  return (
    <Modal
      onClose={() => setShowModal(false)}
      open={showModal}
      title={<ModalHeader>Subscription Terms</ModalHeader>}
      type="light"
      contentStyle="card"
      width={576}
    >
      <ModalContent className="cur-bg-[#ffffff] cur-p-0">
        <Typography className={'cur-p-4'}>
          By signing up for your Curology subscription, you agree to automatic,
          recurring, and continuous charges in the amount and frequency listed
          above for the plan you selected, to the payment method you have on
          file for your Curology account. You may cancel your subscription at
          any time by visiting Payment.
          <br />
          <br />
          Your use of the Curology website, (including but not limited to the
          Curology service, products, and the subscription program terms) is
          subject to Curology&apos;s Terms of Service.
        </Typography>
      </ModalContent>
      <ModalFooter>
        <Button
          className="cur-w-full"
          data-sentry-id="Close modal"
          onClick={() => setShowModal(false)}
          size="lg"
          buttonType="secondary"
        >
          Done
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SubscriptionTermsModal;
